import { Vue, Component, Mixins } from "vue-property-decorator";
import MatrixSidebarMixin from "./MatrixSidebarMixin";
import { namespace } from "vuex-class";
import { CameraSearch, CameraType } from "@/store/site-monitor-cameras/types";

const SiteMonitorCameras = namespace("siteMonitorCameras");

@Component
export default class MatrixCameraMixin extends Mixins(MatrixSidebarMixin) {
	@SiteMonitorCameras.Getter("getMediaMatrixLastChanged") public mediaMatrixLastChanged: number;
	@SiteMonitorCameras.Getter("getDeviceControllerCameras") public cameras: CameraType[];
	@SiteMonitorCameras.Getter public searchedCameras: CameraSearch[];

	@SiteMonitorCameras.Mutation public highlightCell: (index: number) => void;
	@SiteMonitorCameras.Mutation public unhighlightCell: () => void;
	@SiteMonitorCameras.Mutation public setAwaitingCamera: (camera: {
		objectID: number;
		title: string;
		itemType?: number;
	}) => void;

	public selectCamera(camera: CameraType) {
		if (this.isController) {
			this.setAwaitingCamera(camera);
		}
	}

	public cameraSelectedClass(camera: CameraType) {
		return camera.index !== null && !isNaN(camera.index) ? "active" : "";
	}

	public cameraIconColour(content: any, i: number, j: number) {
		return (i - 1) * this.layoutHorizontal + j === content.index ? "redCameraIndicator" : "greyCameraIndicator";
	}
}
